import { ContentWrapper } from "@/components/layout/content";
import { GlitchText } from "@/components/ui/GlitchText";

export function TechStackSection() {
  return (
    <section className="py-24 bg-transparent relative" id="stack">
      <ContentWrapper>
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-mono font-bold text-gray-50">
            <GlitchText text="Technical Stack & Creative Arsenal" glitchClassName="text-cyan-400" />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Frontend & UI */}
          <div className="bg-gray-900 border border-gray-800 p-8 rounded-sm relative group overflow-hidden hover:border-cyan-500/50 transition-colors flex flex-col">
            <h3 className="text-xl font-mono font-bold text-cyan-400 mb-2">[ Frontend & UI ]</h3>
            <p className="text-gray-300 font-sans italic mb-6">Mantra: Intuitive UI-Architektur.</p>
            <div className="flex flex-wrap gap-2 mt-auto">
              {["React", "Angular", "TailwindCSS", "Figma"].map((tag) => (
                <span
                  key={tag}
                  className="text-xs font-mono bg-gray-950 text-cyan-400 px-3 py-1.5 rounded-sm border border-gray-800"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Backend & Infrastructure */}
          <div className="bg-gray-900 border border-gray-800 p-8 rounded-sm relative group overflow-hidden hover:border-emerald-500/50 transition-colors flex flex-col">
            <h3 className="text-xl font-mono font-bold text-emerald-400 mb-2">
              [ Backend & Infrastructure ]
            </h3>
            <p className="text-gray-300 font-sans italic mb-6">
              Mantra: Skalierbare Logik & sichere Systeme.
            </p>
            <div className="flex flex-wrap gap-2 mt-auto">
              {[".NET", "Node.js", "PHP", "Python"].map((tag) => (
                <span
                  key={tag}
                  className="text-xs font-mono bg-gray-950 text-emerald-400 px-3 py-1.5 rounded-sm border border-gray-800"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Creative & Visual */}
          <div className="bg-gray-900 border border-gray-800 p-8 rounded-sm relative group overflow-hidden hover:border-purple-500/50 transition-colors flex flex-col">
            <h3 className="text-xl font-mono font-bold text-purple-400 mb-2">
              [ Creative & Visual ]
            </h3>
            <p className="text-gray-300 font-sans italic mb-6">
              Mantra: Kompromisslose Ästhetik in Pixel & Print.
            </p>
            <div className="flex flex-wrap gap-2 mt-auto">
              {["Photography", "Print Design", "Brand Aesthetics"].map((tag) => (
                <span
                  key={tag}
                  className="text-xs font-mono bg-gray-950 text-purple-400 px-3 py-1.5 rounded-sm border border-gray-800"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </ContentWrapper>
    </section>
  );
}
